import { render } from "./ChangeLayout.vue?vue&type=template&id=4730b73e&scoped=true"
import script from "./ChangeLayout.vue?vue&type=script&lang=js"
export * from "./ChangeLayout.vue?vue&type=script&lang=js"

import "./ChangeLayout.vue?vue&type=style&index=0&id=4730b73e&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4730b73e"]])

export default __exports__